export default {"logMessage": "73ae41c move to cloudflare pages","hash":"73ae41cb44e7df6d8973b234b318d4a594e0d065"}
